import React, {ReactNode} from 'react';
import {motion} from 'framer-motion';

interface FeatureCardProps {
    title: string;
    description: string;
    icon: ReactNode;
    iconColorClass?: string;
}

export default function FeatureCard({title, description, icon, iconColorClass = 'text-success'}: FeatureCardProps) {
    const itemVariants = {
        hidden: {opacity: 0, y: 20},
        visible: {
            opacity: 1,
            y: 0,
            transition: {duration: 0.6}
        }
    };

    return (
        <motion.div
            className="h-100 rounded-4 overflow-hidden position-relative"
            style={{
                background: 'linear-gradient(145deg, rgba(42, 51, 66, 0.35) 0%, rgba(26, 26, 46, 0.55) 100%)',
                border: '1px solid rgba(255, 255, 255, 0.06)',
            }}
            variants={itemVariants}
            whileHover={{
                borderColor: 'rgba(42, 209, 103, 0.2)',
                boxShadow: '0 8px 32px rgba(42, 209, 103, 0.08)',
                transition: {duration: 0.25}
            }}
        >
            <div style={{
                height: 3,
                background: iconColorClass === 'text-warning'
                    ? 'linear-gradient(90deg, #f59e0c 0%, rgba(245, 158, 12, 0.3) 100%)'
                    : 'linear-gradient(90deg, #2ad167 0%, rgba(42, 209, 103, 0.3) 100%)',
            }}/>
            <div className="p-4 text-center">
                <div className="mb-3">
                    <i className={`bi ${icon} fs-3 ${iconColorClass}`}></i>
                </div>
                <h3 className="text-white fw-semibold mb-2" style={{fontSize: '1.05rem'}}>
                    {title}
                </h3>
                <p className="mb-0" style={{color: 'rgba(255, 255, 255, 0.55)', fontSize: '0.88rem', lineHeight: 1.7}}>
                    {description}
                </p>
            </div>
        </motion.div>
    );
}
